module.exports = __webpack_public_path__ + "media/customizations/sunterralakeslife/back-86ec9e20cb86cbfd881b774289308a39.jpg";